document.addEventListener('DOMContentLoaded', function() {

	/**
	 * Reveal and hide site header on scroll.
	 */
	const siteHeader = document.querySelector('.site-header');
	const scrollHide = 'scroll-hide';
	const scrollReveal = 'scroll-reveal';
	const scrollDelta = 5;
	let didScroll = false;
	let lastScroll = 0;

	// Event listener for scroll.
	window.addEventListener('scroll', () => {
		didScroll = true;
	});

	// Set interval to not check for scrolling instantly.
	setInterval(function() {
		if (didScroll) {
			handlePageScroll();
			didScroll = false;
		}
	}, 100);

	// Handle page scroll.
	function handlePageScroll() {
		const currentScroll = window.pageYOffset;

		if (Math.abs(lastScroll - currentScroll) <= scrollDelta) {
			return;
		}

		if ( currentScroll <= scrollDelta ) {
			// Reached top.
			siteHeader.classList.remove(scrollReveal);
		} else if (currentScroll > lastScroll && currentScroll > siteHeader.offsetHeight) {
			// Scrolling down.
			siteHeader.classList.remove(scrollReveal);
			siteHeader.classList.add(scrollHide);
		} else if (currentScroll < lastScroll && siteHeader.classList.contains(scrollHide)) {
			// Scrolling up.
			siteHeader.classList.remove(scrollHide);
			siteHeader.classList.add(scrollReveal);
		}

		lastScroll = currentScroll;
	}

	// Handle header search and foldout menu.
	const foldoutMenu = document.querySelector('.site-header__foldout-menu');
	const foldoutMenuButton = document.querySelector('.site-header__top__menu button');

	const headerSearch = document.querySelector('.site-header-search');
	const headerSearchButton = document.querySelector('.site-header__top__search a');

	// Header search.
	if (headerSearchButton) {
		headerSearchButton.addEventListener('click', (event) => {
			event.preventDefault();

			// Hide foldout menu.
			siteHeader.classList.remove('site-header--foldout-menu-visible');
			foldoutMenu.classList.remove('site-header__foldout-menu--visible');

			// Show header search.
			headerSearch.classList.toggle('site-header-search--visible');
			headerSearch.querySelector('input[name="s"]').focus();

			// Change site header layout.
			siteHeader.classList.toggle('site-header--search-visible');

			// Disable page scroll.
			document.body.classList.toggle('disable-page-scroll');
		});
	}

	// Foldout menu.
	foldoutMenuButton.addEventListener('click', function(event) {

		// Hide header search.
		siteHeader.classList.remove('site-header--search-visible');
		headerSearch.classList.remove('site-header-search--visible');

		// Show foldout menu.
		foldoutMenu.classList.toggle('site-header__foldout-menu--visible');

		// Change site header layout.
		siteHeader.classList.toggle('site-header--foldout-menu-visible');

		// Disable page scroll.
		document.body.classList.toggle('disable-page-scroll');
	});

	// const foldoutMenuChildNodes = foldoutMenu.querySelectorAll('.menu-item-has-children');
	const foldoutMenuChildNodes = foldoutMenu.querySelectorAll('.page_item_has_children');
	foldoutMenuChildNodes.forEach(item => {
		item.insertAdjacentHTML('afterbegin', '<button>+</button>');
	});

	const foldoutMenuToggles = foldoutMenu.querySelectorAll('button');
	foldoutMenuToggles.forEach(button => {
		button.addEventListener('click', function(event) {
			event.target.classList.toggle('open');
			// const submenu = event.target.parentElement.querySelector('.sub-menu');
			// submenu.classList.toggle('sub-menu--visible');
			const submenu = event.target.parentElement.querySelector('.children');
			submenu.classList.toggle('children--visible');
		});
	});

	// Handle sub-nav on small screens.
	const subNav = document.querySelector('.sub-nav');

	if (subNav) {
		const subNavButton = subNav.querySelector('.sub-nav__root__expand button');
		const subNavMenu = subNav.querySelector('.sub-nav__menu');
		subNavButton.addEventListener('click', (event) => {
			subNavButton.classList.toggle('open');
			subNavMenu.classList.toggle('sub-nav__menu--visible');
		});
	}

	// Handle newsletter forms.
	const newsletterForms = document.querySelectorAll('.newsletter-form form');
	newsletterForms.forEach(form => {
		form.addEventListener('submit', handleNewsletterFormSubmit);
	});

	function handleNewsletterFormSubmit( event ) {
		event.preventDefault();

		const form = event.srcElement;
		const formContainer = form.closest('.newsletter-form');
		const formTerms = form.querySelector('input[name="terms"]');

		// Verify terms are accepted.
		if (formTerms.checked) {

			const formData = {
				email: form.querySelector('input[type="email"]').value,
				_wpnonce: form.querySelector('input[name="_wpnonce"]').value,
				_wp_http_referer: form.querySelector('input[name="_wp_http_referer"]').value
			};

			fetch(form.action, {
				method: 'post',
				mode: 'same-origin',
				headers: {
					'Content-type': 'application/json; charset=UTF-8',
					'X-WP-Nonce': form.querySelector('input[name="_wpnonce"]').value
				},
				body: JSON.stringify(formData)
			})
			.then(formData)
			.then(function (data) {

				// Hide form.
				form.style.display = 'none';

				// Show confirmation.
				formContainer.querySelector('.newsletter-form__confirmation').style.display = 'block';

				// Save GA event.
				if ( typeof ga === 'function' ) {
					ga('send', 'event', 'newsletter', 'subscribe');
				}
			})
			.catch(function (error) {
				alert(settings.newsletter.registration_error_message);
			});
		}
	}

	// Fund disclosure texts.
	const fundDisclosureTexts = document.querySelector('.fund-disclosure-texts');

	if (fundDisclosureTexts) {
		const fundDisclosureTextsItems = document.querySelectorAll('.fund-disclosure-texts__item');
		const fundDisclosureTextsItemTitles = document.querySelectorAll('.fund-disclosure-texts__item h3');

		fundDisclosureTextsItemTitles.forEach(fundDisclosureTextsItemTitle => {
			fundDisclosureTextsItemTitle.addEventListener('click', function(event) {
				const parent = event.target.closest('.fund-disclosure-texts__item');

				fundDisclosureTextsItems.forEach(item => {
					if (item !== parent) {
						item.classList.remove('fund-disclosure-texts__item--open');
					}
				});

				parent.classList.toggle('fund-disclosure-texts__item--open');
			});
		});
	}
});
